export var calendarLocale = {
  // months list by order
  months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  // week days by order
  weekDays: [{
    name: 'Понедельник',
    short: 'Пн'
  }, {
    name: 'Вторник',
    short: 'Вт'
  }, {
    name: 'Среда',
    short: 'Ср'
  }, {
    name: 'Четверг',
    short: 'Чт'
  }, {
    name: 'Пятница',
    short: 'Пт'
  }, {
    name: 'Суббота',
    short: 'Сб',
    isWeekend: true
  }, {
    name: 'Воскресенье',
    short: 'Вс',
    isWeekend: true
  }],
  // just play around with this number between 0 and 6
  weekStartingIndex: 6,
  // return a { year: number, month: number, day: number } object
  getToday: function getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },
  // return a native JavaScript date here
  toNativeDate: function toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },
  // return a number for date's month length
  getMonthLength: function getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },
  // return a transformed digit to your locale
  transformDigit: function transformDigit(digit) {
    return digit;
  },
  // texts in the date picker
  nextMonth: 'Следующий месяц',
  previousMonth: 'Предыдущий месяц',
  openMonthSelector: 'Выбрать месяц',
  openYearSelector: 'Выбрать год',
  closeMonthSelector: 'Закрыть',
  closeYearSelector: 'Закрыть',
  defaultPlaceholder: 'Выбрать...',
  // for input range value
  from: 'от',
  to: 'до',
  // used for input value when multi dates are selected
  digitSeparator: ',',
  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,
  // is your language rtl or ltr?
  isRtl: false
};